var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainTran',{attrs:{"data_new":_vm.data,"boolUser_new":_vm.boolUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }